import { request } from '@/utils/request';

export function getMiniProgram() {
  return request('/local/miniProgram');
}

export function getChannel() {
  return request('/local/channel');
}

export function getLink() {
  return request('/local/link');
}

export function uploadFile(file: FormData) {
  return request('/local/upload', {
    method: 'post',
    data: file
  })
}
